import Defines       from './upgrade-defines.es6';
import { openPopup } from '../lib/util.es6';

export default {
    initialize (options, upgrade) {
    },
    events: {
        'buttonClick .upgradePayment__confirm-country-button': 'onPayPalConfirmCountry',
        'buttonClick .upgradePayment__cancel-paypal': 'onPayPalCancel',
    },
    onPayPalCancel (e) {
        e.preventDefault();
        this.doPayPalCancel();
    },
    onPayPalConfirmCountry (e) {
        e.preventDefault();
        this.extendState({
            paypal: 'progress',
            paypal_error: null
        });
        let country = $(e.target).data('country');
        this.model.completePayPalSubscription({
            'token': this.state.paypal_response.token,
            'PayerID': this.state.paypal_response.payer_id,
            'type': this.state.paypal_response.type,
            country
        }, (completeResponse) => {
            if (completeResponse.success) {
                this.paypalDone();
            } else {
                this.setPayPalPayError(completeResponse);
            }
        });
    },
    doPayPalCancel () {
        this.paypalClosed();
        this.clearState(
            'paypal',
            'paypal_method',
            'paypal_response',
            'paypal_confirm_countries',
            'paypal_error'
        );
    },
    paymentHandlers: {
        paypal () {
            switch (this.state.chosen) {
            case Defines.SCHEDULE_MONTHLY_RECURRING:
                this.startPaypal();
                break;
            case Defines.SCHEDULE_ANNUAL_ONEOFF:
                this.startPaypal('oneoff');
                break;
            case Defines.SCHEDULE_ANNUAL_RECURRING:
                this.startPaypal('yearly');
                break;
            }
        },
    },
    startPaypal (type) {
        this.extendState({
            paypal: 'waiting',
            paypal_error: null,
        });
        let url = '/chat/subscribe-solo-paypal';
        if (type) {
            url += '?type=' + type;
        }
        [this.popup, this.popupWatcher] = openPopup(url, 'paypal', {
            closeCallback: _.bind(this.doPayPalCancel, this)
        });
        this.popupResponsePromise = this.model.findMessage(_.bind(function (event) {
            if (event.source !== this.popup) {
                return false;
            }
            return event.data;
        }, this)).done(_.bind(function (response) {
            if (response.success) {
                this.paypalSuccess(response);
            } else {
                this.paypalError(response);
            }
        }, this));
    },
    paypalClosed () {
        // Popup closes itself after a timeout to allow post messages to arrive
        // but we can close it early if we've received the message.
        if (this.popup && !this.popup.closed) {
            this.popup.close();
        }
        clearInterval(this.popupWatcher);
        if (this.popupResponsePromise && this.popupResponsePromise.cleanup) {
            this.popupResponsePromise.cleanup();
        }
        this.popup = null;
        this.popupWatcher = null;
        this.popupResponsePromise = null;
    },
    paypalSuccess () {
        debug.log('<- [PAYPAL] success');
        this.paypalClosed();
        this.paypalDone();
    },
    paypalError (error) {
        debug.warn('<- [PAYPAL]', error);
        this.paypalClosed();
        this.setPayPalPayError(error);
    },
    
    setPayPalPayError (response) {
        let html;
        switch (response.message) {
        case 'country_mismatch':
            this.setConfirmPaypalCountry(response);
            return;
        case 'request_error':
            html = 'Temporary subscription error, please wait, and contact <a href="mailto:team@irccloud.com">team@irccloud.com</a> if this problem doesn’t resolve itself.';
            break;
        case 'invalid_funding_source':
            html = "The PayPal funding source you chose isn't valid for recurring payments, please try again and choose another source.";
            break;
        case 'payment_declined':
            html = "PayPal has declined this payment attempt";
            break;
        case 'payment_blocked':
            html = "This payment attempt is not accepted";
            break;
        case 'duplicate_payment_attempt':
            html = "This PayPal payment attempt has already succeeded. You have not been double charged";
            break;
        case 'token_expired':
            html = "Your PayPal payment attempt has expired. Please try again, you have not been charged.";
            break;
        case 'no_funding_source':
            html = "You don't have a valid funding source on your PayPal account. We can't accept PayPal balance for recurring payments.";
            break;
        default:
            html = 'PayPal payment failed, try again later';
        }
        this.extendState({
            paypal: 'idle',
            paypal_method: [this.getPaymentPayPal()],
            paypal_error: html,
        });
    },
    paypalDone () {
        this.upgrade.payDone();
        this.setInitialState();
    },
    setConfirmPaypalCountry (response) {
        let seen = {};
        let paypal_confirm_countries = [];
        _.each(response.country_evidence, (code, key) => {
            if (code) {
                let keyMatch = key.match(/(.*)_code$/);
                if (keyMatch && !(code in seen)) {
                    seen[code] = true;
                    let type = keyMatch[1];
                    let name = response.country_evidence[type + '_name'];
                    let label = this.upgrade.getCountryEvidenceLabel(type);
                    paypal_confirm_countries.push({
                        type,
                        label,
                        name,
                        code,
                    });
                }
            }
        });
        this.extendState({
            paypal: 'confirm_country',
            paypal_response: response,
            paypal_confirm_countries,
        });
    },
    getPaymentPayPal () {
        return {
            button: 'Pay with PayPal',
            methods: [{
                img: '/static/cards/paypal-curved-32px.png',
                alt: 'PayPal',
                width: 51,
                height: 32
            }],
            value: 'paypal',
            img: '/static/PP_logo_h_100x26.png',
            alt: 'PayPal',
            width: 100,
            height: 26
        };
    },
};



// WEBPACK FOOTER //
// ./app/src/view/upgrade-paypal.es6